<template>
	<form-remote-select v-bind="props"
						@update:modelValue="value => emit('update:modelValue', value)"
						action="/v1/suggests"
						text-prop="name"
						value-prop="id"
						subtitle-prop="subtitle"
						group-prop="type_name"
						image-prop="image"
						:data="{limit: 10}"
						as-guest/>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
}>(), {});
const emit = defineEmits(['update:modelValue']);
</script>